import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 获取会员用户列表
export function getShopTelUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.queryShopTelUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取会员账户列表
export function getShopVipAccount(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/account.queryShopVipAccount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取会员积分列表
export function getShopLinkIntegral(params) {
  params.objType = '6006'
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.queryShopLinkIntegral',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取积分明细列表
export function getShopLinkIntegralDetail(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.queryShopLinkIntegralDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取会员订单列表
export function getStoreOrderCart(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrderCart',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取退款订单列表
export function getShopRefundOrders(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/refundOrder.queryShopRefundOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取拼团订单列表
export function listProductGroupOrder(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.listProductGroupOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取拼团退单列表
export function queryShopRefundGroupOrder(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.queryShopRefundGroupOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取秒杀订单列表
export function listProductSeckillOrder(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.listProductSeckillOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取收货地址列表
export function queryShopUserAddress(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userAddress.queryShopUserAddress',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取会员详情
export function getShopVipUser(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser.queryShopVipUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}